<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="edit-user-card">
                <button type="button" @click="$emit('close')" class="modal-close-btn">
                    X
                </button>

                <div class="d-flex flex-column">
                    <div class="confirmation-header">Remove {{deleteTeamName}} team?</div>
                    <div class="confirmation-body">
                        All users will not be able to see {{deleteTeamName}} team from their team list anymore.
                    </div>
                </div>

                <div class="d-flex justify-content-center mt-3">
                    <button class="btn wfh-btn-primary-outline flex-grow-1 mr-3"
                            @click="$emit('close')">Cancel
                    </button>
                    <button class="btn wfh-btn-primary flex-grow-1" style="width: auto;" @click="$emit('confirm')">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['deleteTeamName'],
    name: 'DeleteTeamPromptModal',
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}
</style>
